import { updateBirthdayCalendarInitialState } from '../actions/internalActions';
import loadCalendarFolders from '../services/loadCalendarFolders';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import GetCalendarFoldersResponse from 'owa-service/lib/contract/GetCalendarFoldersResponse';
import LocalCalendarEntry from 'owa-service/lib/contract/LocalCalendarEntry';

/**
 * 1. Gets the calendar folder and groups data from the server
 * 2. Parses the data to determine if birthday calendar is part of the user's calendars
 */
export default async function initBirthdayCalendarOption() {
    let calendarFoldersResponse = await loadCalendarFolders();
    if (
        calendarFoldersResponse.CalendarFolders &&
        calendarFoldersResponse.CalendarFolders.length &&
        calendarFoldersResponse.CalendarGroups &&
        calendarFoldersResponse.CalendarGroups.length
    ) {
        let initialState = isBirthdayCalendarPresent(calendarFoldersResponse);
        updateBirthdayCalendarInitialState(initialState);

        return true;
    }
    return false;
}

/**
 * Utility function to parse calendar groups to check for birthday calendar
 * @returns boolean indicating whether or not birthday calendar is present
 */
function isBirthdayCalendarPresent(calendarFoldersResponse: GetCalendarFoldersResponse): boolean {
    let calendarGroups = calendarFoldersResponse.CalendarGroups;

    for (let i = 0; i < calendarGroups.length; i++) {
        let calendars: LocalCalendarEntry[] = calendarGroups[i].Calendars;
        for (let j = 0; j < calendars.length; j++) {
            let calendarEntry: LocalCalendarEntry = calendars[j];

            if (!calendarEntry.CalendarFolderId) {
                continue;
            }

            if (calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.BirthdayCalendar) {
                return true;
            }
        }
    }

    return false;
}
